import React from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const SingleProject = ({ name, liveSiteLink, clientSideRepo, serverSideRepo, techStack, image, id }) => {
    return (
        <div className="card w-3/4 lg:w-96 h-full bg-base-100 shadow-xl relative font-mono">
            <figure><img src={image} alt="Shoes" /></figure>
            <div className="card-body">
                <h2 className="card-title">
                    {name}
                </h2>
                <div className="card-actions justify-end">
                    {
                        techStack.map((tech, index) => <div key={index} className="badge badge-outline">{tech}</div>)
                    }

                </div>
                <div className='flex flex-wrap justify-center my-5'>
                    {serverSideRepo ? <>
                        <a rel='noreferrer' target={"_blank"} href={clientSideRepo}><button className='btn bg-cyan-900 btn-sm mr-2 mt-2'>GitHub | Client</button></a>
                        <a rel='noreferrer' target={"_blank"} href={serverSideRepo}><button className='btn bg-cyan-900 btn-sm mr-2 mt-2'>GitHub | Server</button></a>
                    </>
                        :
                        <a rel='noreferrer' target={"_blank"} href={clientSideRepo}><button className='btn bg-cyan-900 btn-sm mr-2 mt-2'>GitHub Repository</button></a>
                    }

                    <a rel='noreferrer' target={"_blank"} href={liveSiteLink}><button className='btn bg-cyan-900 btn-sm mr-2 mt-2'>Visit Live Site</button></a>
                </div>
                <div className='flex justify-center w-full'>
                    <Link className='btn border-0 rounded-sm bg-cyan-600 w-full absolute bottom-0 font-bold text-xl' to={`/projectDetail/${id}`}>Explore Project</Link>
                </div>
            </div>
        </div>
    );
};

export default SingleProject;